import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import { ProductName } from '@keytrade/components-productname';
import { config } from '@keytrade/functions';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

const Wrapper = styled.div`
  margin-bottom: 0.8rem;
`;

type CategoryProps = {
  dark: boolean;
  small: boolean;
};

const Category = styled.div<CategoryProps>`
  text-transform: uppercase;
  color: ${({ dark }) => (dark ? colors.BlueLight : colors.GreyBlue)};
  font-size: ${({ small }) => (small ? '1.4rem' : '1.6rem')};
  font-family: ${({ theme }) => getFont(theme, 'bold')};
`;

type Props = {
  data: {
    product?: string;
    title?: string;
  };
  dark: boolean;
  small?: boolean;
};
const About: React.FC<Props> = ({ data, dark, small }) => {
  return (
    <Wrapper>
      {data.product ? (
        <ProductName
          size={small ? 'xxxs' : 'xxs'}
          darkTheme={dark}
          type={data.product && data.product.toLowerCase()}
        />
      ) : (
        <Category dark={dark} small={small}>
          {data.title}
        </Category>
      )}
    </Wrapper>
  );
};

export type AboutType = {
  product?: string;
  title?: string;
};

export default About;

export const aboutQuery = graphql`
  fragment AboutFragment on ContentfulProductNameContentfulCategoryUnion {
    ... on ContentfulProductName {
      __typename
      product
    }
    ... on ContentfulCategory {
      __typename
      title
    }
  }
`;
